import React, { Component } from 'react'
import { modal_time, _getLocalLanguage } from './Constants';
import { lang_en } from './language/en';
import { lang_hi } from './language/hi';
import {
    Link
} from "react-router-dom";
import withNavigateHook from './withNavigateHook';
const language = _getLocalLanguage();
let $ = window.$;

class MedicalConfirmModal extends Component {

    constructor(props) {
        super(props);
        // state declaration
        this.state = {
            text_language: language.lang == 'en' ? lang_en : lang_hi,
            message: this.props.message,
            type: this.props.type,
            visibility: this.props.visibility,
            form_data: this.props.form_data
        }

    }


    /**
     * 
     */
    _checkVisibility = () => {

        if (this.props.visibility == 'show') {
            //window.startConfetti();
            $('#modal-4').modal({
                dismissible: false
            });

            $('#modal_booking_trigger')[0].click();
            setTimeout(() => {
                //$('#modal-4').modal('close');
            }, modal_time);
        }
    }

    /**
     * 
     * @param {*} e 
     * @returns 
     */
    _continueApp = (e) => {
        e.preventDefault();
        if (this.props.type == 'success') {
            $('#modal-4').modal('close');
            return (
                this.props.navigation("/previous-medical-delivery")
            )
        } else {
            $('#modal-4').modal('close');
        }

    }

    render() {

        return (
            <div>
                {
                    this._checkVisibility()
                }
                <a className="waves-effect waves-light btn modal-trigger" id="modal_booking_trigger" style={{ display: "none" }} href="#modal-4">Modal</a>
                {
                    this.props.type == "success"
                        ?
                        <div id="modal-4" className="modal br-radius custom-modal">
                            {console.log(this.props.form_data.get('app_charges'))}
                            <div className="modal-content">
                                <div className='teal lighten-2'>
                                    <h1 className='center-align modal-header'>{this.state.text_language[0].order_confirmation_text}</h1>
                                    <h6 className='center-align pb-10 white-text'>{this.state.text_language[0].order_added_text}</h6>
                                </div>
                                {
                                    $.isEmptyObject(this.props.form_data) != true ?
                                        <div className='row center-align'>
                                            <div className='col s6'>
                                                <p><b>{this.state.text_language[0].patient_text} {this.state.text_language[0].name_text}:</b> {this.props.form_data.get('name')}</p>
                                            </div>
                                            <div className='col s6'>
                                                <p><b>{this.state.text_language[0].patient_text} {this.state.text_language[0].phone_text}:</b> {this.props.form_data.get('phone_number')}</p>
                                            </div>

                                            <div className='col s6'>
                                                <p><b>{this.state.text_language[0].delivery_text} {this.state.text_language[0].date_text}:</b> {this.props.form_data.get('delivery_date')}</p>
                                            </div>
                                            <div className='col s6'>
                                                <p><b>{this.state.text_language[0].delivery_text} {this.state.text_language[0].fees_text}:</b> {this.props.form_values.delivery_charges}</p>
                                                {
                                                    this.props.form_data.get('delivery_type') == 'Urgent'
                                                        ?
                                                        <small id="urgent-delivery-text">{this.state.text_language[0].km_charges_text}</small>
                                                        :
                                                        ''
                                                }

                                            </div>
                                            <div className='col s6'>
                                                <p><b>{this.state.text_language[0].delivery_type_text}:</b> {this.props.form_data.get('delivery_type')}</p>
                                            </div>
                                            <div className='col s6'>
                                                <p><b>{this.state.text_language[0].delivery_text} {this.state.text_language[0].address_text}:</b> {this.props.form_data.get('patient_address')}</p>
                                            </div>

                                        </div>
                                        :
                                        ""
                                }


                                <div className="row">
                                    <div className="col s12">
                                        <div className="card blue-grey lighten-1">
                                            <div className='row'>
                                                <div className="col s12 white-text center-align">
                                                    <h6 className="pt-10">{this.state.text_language[0].for_any_query_text}</h6>

                                                </div>
                                                <div className="col s12">
                                                    <div className="card-content white-text no-padding">
                                                        <div className='row'>
                                                            <div className='col m4 s4 right-align'>
                                                                <p><img className="responsive-img h-40" src="images/telephone-call.png" alt="Welcome" /></p>
                                                            </div>
                                                            <div className='col m8 s8'>
                                                                <p className='mt-10'><a className='active' target="_blank" href="tel:+91 79819 11392">+91 79819 11392</a></p>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col m4 s4 right-align'>
                                                                <p><img className="responsive-img h-40" src="images/whatsapp.png" alt="Welcome" /></p>
                                                            </div>
                                                            <div className='col m8 s8'>
                                                                <p className='mt-10'><a className='active' target="_blank" href="https://wa.me/qr/I2UILYPVUH63B1/">{this.state.text_language[0].contact_us_whatsapp_text}</a></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>

                                </div>

                                <div className='row center-align pt-20'>
                                    {/* <Link to="/previous-medical-delivery" className="btn btn-primary continuebtn ">
                                        {this.state.text_language[0].continue_text}
                                   </Link> */}
                                    <a href="/" onClick={(e) => { this._continueApp(e) }} className="btn btn-primary continuebtn ">{this.state.text_language[0].continue_text}</a>

                                </div>
                            </div>

                        </div>
                        :

                        <div id="modal-4" className="modal br-radius custom-modal">
                            <div className="modal-content">
                                <div className='teal lighten-2'>
                                    <h1 className='center-align modal-header'>{this.state.text_language[0].booking_confirmation_text}</h1>
                                </div>

                                <div className='row center-align'>
                                    <div className='col s12'>
                                        <p><b>{this.state.text_language[0].booking_error_text}</b></p>
                                        <p><b>{this.state.text_language[0].please_try_again_later_text}</b></p>
                                    </div>

                                </div>



                                <div className="row">
                                    <div className="col s12">
                                        <div className="card blue-grey lighten-1">
                                            <div className='row'>
                                                <div className="col s12 white-text center-align">
                                                    <h6 className="pt-10">{this.state.text_language[0].for_any_query_text}</h6>

                                                </div>
                                                <div className="col s12">
                                                    <div className="card-content white-text">
                                                        <div className='row'>
                                                            <div className='col m4 s4 right-align'>
                                                                <p><img className="responsive-img h-40" src="images/telephone-call.png" alt="Welcome" /></p>
                                                            </div>
                                                            <div className='col m8 s8'>
                                                                <p className='mt-10'><a className='active' target="_blank" href="tel:+91 79819 11392">+91 79819 11392</a></p>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col m4 s4 right-align'>
                                                                <p><img className="responsive-img h-40" src="images/whatsapp.png" alt="Welcome" /></p>
                                                            </div>
                                                            <div className='col m8 s8'>
                                                                <p className='mt-10'><a className='active' target="_blank" href="https://wa.me/qr/I2UILYPVUH63B1/">Contact us on Whatsapp</a></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>

                                </div>

                                <div className='row center-align pt-20'>
                                    <a href="/" onClick={(e) => { this._continueApp(e) }} className="btn btn-primary continuebtn ">{this.state.text_language[0].continue_text}</a>

                                </div>
                            </div>

                        </div>
                }



            </div>
        )
    }
}

export default withNavigateHook(MedicalConfirmModal);
